/** 前端 i18n 语言 → 服务端 local / pageLang 枚举 */
const LOCALE_TO_API = {
  zh: 'zh-CN',
  zh_TW: 'zh-TW',
  en: 'en-US',
};

const API_LOCALES = new Set(['zh-CN', 'zh-TW', 'en-US']);

/**
 * @param {string} [lang] 前端 i18n.language（zh / zh_TW / en）
 * @returns {'zh-CN' | 'zh-TW' | 'en-US'}
 */
export function toApiLocale(lang) {
  if (!lang) return 'zh-TW';
  if (LOCALE_TO_API[lang]) return LOCALE_TO_API[lang];
  if (API_LOCALES.has(lang)) return lang;
  return 'zh-TW';
}
